import React from 'react';
import PropTypes from 'prop-types';
import {
  Col,
  ListGroup,
  Row,
} from 'reactstrap';

import SettingsItem from './Item';
import UpgradeBoard from '../../../UpgradeBoard';

import { userHasFeature } from '../../../../helpers/Features';

const SettingsItemsWrapper = ({
  viewAllowedSettings,
  settings,
  hiddenSettings,
  handleSettingChange,
}) => {
  const upgradeBoardFeatureToShow = Object.keys(settings)
    .filter(s => viewAllowedSettings.includes(s))
    .find(s => settings[s].feature_name &&
        !userHasFeature(settings[s].feature_name) &&
        !settings[s].inline_upgrade);

  return (
    <>
      <Row className="settings-row">
        <Col>
          <ListGroup flush className="switch-list workspace-settings-list">
            {Object.keys(settings)
              .filter(s => (viewAllowedSettings.includes(s)))
              .filter(s => (!hiddenSettings.includes(s)))
              .filter(s => (
                !(
                  settings[s].feature_name &&
                  !userHasFeature(settings[s].feature_name) &&
                  !settings[s].inline_upgrade
                )))
              .map(key => (
                <SettingsItem
                  key={key}
                  settingKey={key}
                  setting={settings[key]}
                  handleSettingChange={handleSettingChange}
                />
              ))}
          </ListGroup>
        </Col>
      </Row>
      {upgradeBoardFeatureToShow && (
        <Row className="settings-row">
          <UpgradeBoard feature={settings[upgradeBoardFeatureToShow].feature_name} />
        </Row>
      )}
    </>
  );
};

SettingsItemsWrapper.propTypes = {
  handleSettingChange: PropTypes.func.isRequired,
  settings: PropTypes.object.isRequired,
  hiddenSettings: PropTypes.array.isRequired,
  viewAllowedSettings: PropTypes.array.isRequired,
};

export default SettingsItemsWrapper;
